import { get } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import { SORT_BY_LOW_TO_HIGH } from '../utils/constants';
import queryString from 'query-string';

export const CTA_EVENT = 'ctaClick';
export const SELF_TARGET = '_self';

/**
 * @param {function?} onClick callback function to execute.
 * @param {string?} href url to redirect the user to.
 * @param {string?} target defines if the new url is open in the same tab or a new one.
 */
const executeCallback = (onClick, href, target) => {
  if (onClick) {
    onClick();
  }
  if (href) {
    window.open(href, target);
  }
};

/**
 * Creates a button data object to be set in GTM.
 * @param {string} buttonId componentName where the button is located.
 * @param {string} renderText text that is shown to user.
 */
export const processButtonData = (buttonId, renderText) => {
  const data = {
    buttonId,
    buttonName: renderText,
    ctaTarget: undefined,
    event: CTA_EVENT,
  };
  setDataLayerObj(data);
};

/**
 * Creates a link data object to be set in GTM if the link is trackable.
 * @param {function?} onClick optional function to execute.
 * @param {boolean} isGTMTrackable determines if is necessary to generate a new dataLayer object.
 * @param {object} fieldCta contains all the data in for CTA {href, text, target}.
 */
export const processLinkData = (
  buttonId,
  fieldCta,
  isGTMTrackable = false,
  onClick = null,
) => {
  const { href, text } = fieldCta.value;
  const target = fieldCta.value.target ? fieldCta.value.target : SELF_TARGET;

  if (isGTMTrackable) {
    const data = {
      buttonId,
      buttonName: text,
      ctaTarget: href,
      event: CTA_EVENT,
      eventCallback: function () {
        executeCallback(onClick, href, target);
      },
    };
    setDataLayerObj(data);
  } else {
    executeCallback(onClick, href, target);
  }
};

/**
 * Handles the object to track page load events
 * @param {object} route - provides necesary current page data for GTM.
 */
export const processAnalyticsPageData = route => {
  if (!route || isEmpty(route)) {
    return null;
  }

  const Tags = get(route, 'fields.Tags.value', '');
  let TagArr = {};
  if (Tags) {
    TagArr = queryString.parse(Tags);
  }

  const languageConfig = route.itemLanguage.split('-');
  return {
    pageType: route.templateId,
    pageName: route.name,
    pageTemplate: route.templateName,
    language: languageConfig[0],
    country: languageConfig[1],
    event: 'pageLoad',
    ...TagArr,
  };
};

/**
 * Handles results map interactions
 * @param {object} filters user selection
 */
export const processAnalyticsResultsMapData = mapInteraction => {
  setDataLayerObj({
    event: 'resultsMapInteraction',
    mapInteraction,
  });
};

/**
 * Handles results filters selection
 * @param {object} filters user selection
 */
export const processAnalyticsResultsFilterData = filters => {
  setDataLayerObj({
    event: 'resultsFilterSort',
    resultsFilterName: 'Brands',
    resultsFilterValue: filters.brands,
    resultsSortValue:
      filters.sort === SORT_BY_LOW_TO_HIGH ? 'Low To High' : 'High To Low',
  });
};

/**
 * Sets a data object into window.dataLayer to be collected by GTM.
 * @param {object} data sets data object into window.dataLayer
 */
export const setDataLayerObj = data => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    //console.log({ dataLayerCalledInAppData: data });
  }
};
